import { DataSourceLegacyCheckoutConfigProviderProps } from "./query";

export type DataSource_LegacyCheckoutConfig_QueryKeyType = [
  string,
  Omit<DataSourceLegacyCheckoutConfigProviderProps, "useInitialState">
];

export const DataSource_LegacyCheckoutConfig_QueryKey = {
  legacyCheckoutConfig: (
    desiredBag: DataSourceLegacyCheckoutConfigProviderProps
  ): DataSource_LegacyCheckoutConfig_QueryKeyType => {
    const baseQueryKey = `bbnt-data-source-legacy-checkout-config`;

    const { useInitialState, ...desiredBag_cleaned } = {
      ...desiredBag,
    };

    const queryKey: DataSource_LegacyCheckoutConfig_QueryKeyType = [
      baseQueryKey,
      desiredBag_cleaned,
    ];

    return queryKey;
  },
};
